export const AUTHENTICATOR_PATH_NAME = 'authenticator';
